import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import SettingsView from '../components/SettingsView';
import NotFoundView from '../components/NotFoundView';
import VisitsView from '../components/VisitsView';
import VisitView from '../components/VisitView';
import LoginView from '../components/LoginView';
import MachinesReportsView from '../components/MachinesReportsView';
import ReportActionsView from '../components/ReportActionsView';
import NoInternetConnectionView from '../components/NoInternetConnectionView';

Vue.use(Router);

function createRouter() {
  const router = new Router({

    routes: [
      {
        path: '/',
        name: 'Visits',
        meta: {
          title: 'Vizite'
        },
        component: VisitsView
      },
      {
        path: '/visit/:id',
        name: 'Visit',
        meta: {
          title: ''
        },
        component: VisitView
      },
      {
        path: '/reports-machine-history/:machineId?',
        name: 'MachinesReports',
        meta: {
          title: 'Istoric Aparate'
        },
        component: MachinesReportsView
      },
      {
        path: '/reports-actions',
        name: 'ReportActions',
        meta: {
          title: 'Acțiuni de făcut'
        },
        component: ReportActionsView
      },
      {
        path: '/settings',
        name: 'Settings',
        meta: {
          title: 'Setări'
        },
        component: SettingsView
      },
      // Global redirect for 404
      {
        path: '*',
        redirect: '/404'
      },
      {
        path: '/404',
        name: 'NotFound',
        component: NotFoundView
      },
      {
        path: '/503',
        name: 'NoInternetConnection',
        component: NoInternetConnectionView
      },
      {
        path: '/login',
        name: 'Login',
        meta: {
          title: 'Login'
        },
        component: LoginView
      }
    ]

  });

  function isQuotaExceeded(e) {
    var quotaExceeded = false;
    if (e) {
      if (e.code) {
        switch (e.code) {
          case 22:
            quotaExceeded = true;
            break;
          case 1014:
            // Firefox
            if (e.name === 'NS_ERROR_DOM_QUOTA_REACHED') {
              quotaExceeded = true;
            }
            break;
        }
      } else if (e.number === -2147024882) {
        // Internet Explorer 8
        quotaExceeded = true;
      }
    }
    return quotaExceeded;
  }

  router.beforeEach((to, from, next) => {
    if (to.path !== '/login' && (to.name !== 'NoInternetConnection' && from.name !== 'NoInternetConnection')) {
      if (checkAuthUser()) {
        store.commit('PAGE_TITLE', to.meta.title);
        if (from.name !== null) {
          store.commit('FROM_PAGE', from.path);
          try {
            localStorage.setItem('fromPage', from.path);
          } catch (error) {
            if (isQuotaExceeded(error)) {
              console.log('Not enough storage');
            }
          }
        } else {
          let fromPage = localStorage.getItem('fromPage');
          if (fromPage) {
            store.commit('FROM_PAGE', fromPage);
          } else {
            store.commit('FROM_PAGE', 'Visits');
          }
        }
        document.title = store.state.pageTitle + ' | TEK';
        next();
      } else {
        next('login');
      }
    } else {
      store.commit('PAGE_TITLE', to.meta.title);
      document.title = store.state.pageTitle + ' | TEK';
      next();
    }
  });

  function checkAuthUser() {
    const token = localStorage.getItem('token');

    if (store.state.token) {
      return true;
    } else if (token) {
      store.commit('TOKEN', token);
      return true;
    } else {
      return false;
    }
  }

  return router;
}

export default createRouter();
